<template>
  <div class="md-layout md-gutter" v-if="Object.keys(cluster).length">
    <div
      class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20 small-size-style"
    >
      <box
        :box-color="'blue'"
        :center-text="true"
        :header-text="$tc('words.site')"
        :header-text-color="'#dddddd'"
        :sub-text="miniGridCount.toString()"
        :sub-text-color="'#e3e3e3'"
        :box-icon="'map'"
      />
    </div>
    <div
      class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20 small-size-style"
    >
      <box
        :box-color="'orange'"
        :center-text="true"
        :header-text="$tc('words.people')"
        :sub-text="cluster.population.toString()"
        :box-icon="'supervisor_account'"
      />
    </div>
    <div
      class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20 small-size-style"
    >
      <box
        :box-color="'red'"
        :center-text="true"
        :header-text="$tc('phrases.connectedMeters')"
        :sub-text="cluster.meterCount.toString()"
        :box-icon="'settings_input_hdmi'"
      />
    </div>
    <div
      class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20 small-size-style"
    >
      <box
        :box-color="'purple'"
        :center-text="true"
        :header-text="$tc('phrases.soldAppliances')"
        :sub-text="applianceCount.toString()"
        :box-icon="'shopping_cart'"
      />
    </div>
    <div
      class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-20 small-size-style"
    >
      <box
        v-if="cluster.revenue.toString()"
        :box-color="'green'"
        :center-text="true"
        :header-text="
          $tc('words.revenue') +
          ' (' +
          $tc('phrases.lastXDays', 1, { x: 30 }) +
          ')'
        "
        :sub-text="
          readable(cluster.revenue) +
          $store.getters['settings/getMainSettings'].currency
        "
        :box-icon="'attach_money'"
      />
    </div>
  </div>
</template>

<script>
import { currency } from "@/mixins/currency.js"
import Box from "@/shared/Box.vue"

export default {
  name: "BoxGroup",
  components: { Box },
  mixins: [currency],
  props: {
    cluster: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    boxData: [],
  }),
  computed: {
    miniGridCount() {
      const clusterData = this.cluster.clusterData
      if (clusterData && clusterData.mini_grids) {
        return clusterData.mini_grids.length
      }
      return 0
    },
    applianceCount() {
      return this.cluster.applianceCount || 0
    },
  },
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 1280px) {
  .small-size-style {
    margin-bottom: 1rem !important;
    min-height: unset;
  }
}
</style>
